export default __webpack_public_path__ + "static/media/moodVeryBad.7e532a6a.png";